import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import { Link } from "react-router-dom";

var LinkAnimation = function LinkAnimation(props) {
  return /*#__PURE__*/React.createElement(Link, {
    style: {
      textDecoration: "none",
      color: "inherit"
    },
    to: {
      pathname: props.to,
      state: _objectSpread(_objectSpread({}, props.state), {}, {
        animation: props.direction ? true : false,
        direction: props.direction || null,
        title: props.title || null,
        action: props.action || null // for shift checkin and checkout

      })
    },
    className: props.classes || null
  }, props.children);
};

export { LinkAnimation };